import {combineReducers} from 'redux';
import {
  APP_PROJECTTYPES_STATE_INIT, IAppProjectType, ISelectorState, IAppToolBar,
  APP_TOOLBAR_STATE_INIT, IAppCatalog, APP_CATALOG_STATE_INIT, APP_FACTORY_SERVICE_STATE_INIT, IAppFactoryService,
  IAppUserInfo, APP_USER_INFO_STATE_INIT, IAppContext, APP_CONTEXT_STATE_INIT, IAppConfig, APP_CONFIG_STATE_INIT
} from '../selector.state';
import {ApplicationProjectTypeActions} from '../Actions/application-project-types-actions';
import {ApplicationToolbarActions} from '../Actions/application-toolbar-actions';
import {
  APP_CLASS_ACDC, APP_CLASS_DCDC, APP_CLASS_LED_ACDC, APP_CLASS_LED_DCDC
} from '../../models/view';
import {ApplicationCatalogActions} from '../Actions/application-catalog-actions';
import {tassign} from '../../common/utils';
import {routerReducer} from "@angular-redux/router";
import {applicationSpecReducer} from "./spec";
import {AcDc_Factory} from "../../solution-type/POWER/acdc/acdc-factory";
import {DcDc_Factory} from "../../solution-type/POWER/dcdc/dcdc-factory";
import {Led_AcDc_Factory} from "../../solution-type/LED/acdc/led-acdc-factory";
import {Led_DcDc_Factory} from "../../solution-type/LED/dcdc/led-dcdc-factory";
import {ApplicationUserInfoActions} from "../Actions/application-user-info-actions";
import {ApplicationContextActions} from "../Actions/application-cotext-actions";
import {isArray, isNullOrUndefined} from "util";
import {IeDsFolder} from "../../models/user-info";
import {ApplicationConfigActions} from "../Actions/application-config-actions";
import * as R from "ramda";

export function applicationProjectTypesReducer(state: IAppProjectType = APP_PROJECTTYPES_STATE_INIT, action: any): IAppProjectType {
  switch (action.type) {
    case ApplicationProjectTypeActions.ActionType.LOADED:
      return tassign(state, {rootMenu: action.payload, breadcrumb: [], error: ''});
    case ApplicationProjectTypeActions.ActionType.LOAD_ERROR:
      return tassign(state, {rootMenu: [], breadcrumb: [], error: action.payload});
    case ApplicationProjectTypeActions.ActionType.LOADED_APP_MAP:
      return tassign(state, {appTypeMap: action.payload, error_appTypeMap: ''});
    case ApplicationProjectTypeActions.ActionType.LOAD_APP_MAP_ERROR:
      return tassign(state, {appTypeMap: null, error_appTypeMap: action.payload});
    case ApplicationProjectTypeActions.ActionType.SET_BREADCRUMB:
      return tassign(state, {breadcrumb: action.payload});
    default:
      return state;
  }
}

export function applicationToolbarReducer(state: IAppToolBar = APP_TOOLBAR_STATE_INIT, action: any): IAppToolBar {
  switch (action.type) {
    case ApplicationToolbarActions.ActionType.VIEW_TYPE:
      return tassign(state, {viewType: action.payload});
    case ApplicationToolbarActions.ActionType.SEARCH:
      return tassign(state, {search: action.payload});
    case ApplicationToolbarActions.ActionType.CHANGE_SORT_DIRECTION:
      return tassign(state, {direction: action.payload});
    case ApplicationToolbarActions.ActionType.SORT_FIELD:
      return tassign(state, {sortField: action.payload});
    case ApplicationToolbarActions.ActionType.SIDE_BAR_OPENED:
      return tassign(state, {sideBarOpened: action.payload});
    case ApplicationToolbarActions.ActionType.SWITCH_SIDE_BAR:
      return tassign(state, {sideBarOpened: !state.sideBarOpened});
    default:
      return state;
  }
}

function applicationUserInfoReduce(state: IAppUserInfo = APP_USER_INFO_STATE_INIT, action: any): IAppUserInfo {
  switch (action.type) {
    case ApplicationUserInfoActions.ActionType.LOADING_USER_DATA:
      return tassign(state, {loadUserData: 'running'});
    case ApplicationUserInfoActions.ActionType.LOAD_USER_DATA_COMPLETED:
      return tassign(state, {loadUserData: 'completed'});
    case ApplicationUserInfoActions.ActionType.SET_USER:
      return tassign(state, {user: action.payload});
    case ApplicationUserInfoActions.ActionType.SET_USER_PROJECTS:
      return tassign(state, {userProjects: action.payload});
    case ApplicationUserInfoActions.ActionType.SET_EXAMPLE_PROJECTS:
      return tassign(state, {exampleProjects: action.payload});
    case ApplicationUserInfoActions.ActionType.SET_CURRENT_USER_FOLDER:
      const _curr: IeDsFolder = action.payload;
      if (isNullOrUndefined(_curr)) {
        const _rootFs = isNullOrUndefined(state.userProjects) ? null : state.userProjects.folder as IeDsFolder;

        // rebuild the currentFolder structure
        const _path = state.currentUserFolder.reduce<IeDsFolder[]>((acc, x, i) => {
          let toAdd = null;
          if (acc.length > 0 && i > 0) {
            if (isArray(acc[acc.length - 1].folder)) {
              toAdd = (acc[acc.length - 1].folder as IeDsFolder[]).find((y) => x.id === y.id && x.label === y.label);
            } else {
              const fold = (acc[acc.length - 1].folder as IeDsFolder);
              toAdd = (x.id === fold.id && x.label === fold.label) ? fold : null;
            }
          }
          return isNullOrUndefined(toAdd) ? acc : [...acc, toAdd];
        }, isNullOrUndefined(_rootFs) ? [] : [_rootFs]);
        return tassign(state, {currentUserFolder: _path});
        // }
      }
      const idx = state.currentUserFolder.indexOf(_curr);
      if (idx < 0) {
        return tassign(state, {currentUserFolder: [...state.currentUserFolder, _curr]});
      } else {
        return tassign(state, {currentUserFolder: state.currentUserFolder.slice(0, idx + 1)});
      }
    case ApplicationUserInfoActions.ActionType.SET_CURRENT_EXAMPLE_FOLDER:
      const _curr1: IeDsFolder = action.payload;
      if (isNullOrUndefined(_curr1)) {
        const _rootFs1 = isNullOrUndefined(state.exampleProjects) ? null : state.exampleProjects.folder as IeDsFolder;

        // rebuild the currentFolder structure
        const _path1 = state.currentExampleFolder.reduce<IeDsFolder[]>((acc, x, i) => {
          let toAdd1 = null;
          if (acc.length > 0 && i > 0) {
            if (isArray(acc[acc.length - 1].folder)) {
              toAdd1 = (acc[acc.length - 1].folder as IeDsFolder[]).find((y) => x.id === y.id && x.label === y.label);
            } else {
              const fold1 = (acc[acc.length - 1].folder as IeDsFolder);
              toAdd1 = (x.id === fold1.id && x.label === fold1.label) ? fold1 : null;
            }
          }
          return isNullOrUndefined(toAdd1) ? acc : [...acc, toAdd1];
        }, isNullOrUndefined(_rootFs1) ? [] : [_rootFs1]);
        return tassign(state, {currentExampleFolder: _path1});
        // }
      }
      const idx1 = state.currentExampleFolder.indexOf(_curr1);
      if (idx1 < 0) {
        return tassign(state, {currentExampleFolder: [...state.currentExampleFolder, _curr1]});
      } else {
        return tassign(state, {currentExampleFolder: state.currentExampleFolder.slice(0, idx1 + 1)});
      }

    default:
      return state;
  }

}

function createFactoryService(appCls: string): IAppFactoryService {
  switch (appCls) {
    case APP_CLASS_ACDC:
      return AcDc_Factory.createService();
    case APP_CLASS_DCDC:
      return DcDc_Factory.createService();
    case APP_CLASS_LED_ACDC:
      return Led_AcDc_Factory.createService();
    case APP_CLASS_LED_DCDC:
      return Led_DcDc_Factory.createService();
    default:
      return APP_FACTORY_SERVICE_STATE_INIT;
  }
}

export function applicationCatalogReducer(state: IAppCatalog = APP_CATALOG_STATE_INIT, action: any): IAppCatalog {
  switch (action.type) {
    case ApplicationCatalogActions.ActionType.LOAD:
      return tassign(state, {
        name: action.payload.name,
        appClass: action.payload.appClass,
        loadComplete: false,
        topologiesFilter: action.payload.topologiesFilter,
        db: [],
        designSolutions: [],
        ledDB: null,
        unableToFindSolution: false,
        error: '',
        selectedSolution: null,
        loading: true,
        service: createFactoryService(action.payload.appClass)
      });
    case ApplicationCatalogActions.ActionType.LOADED:
      return tassign(state, {
        db: action.payload,
        designSolutions: [],
        error: '',
        selectedSolution: null,
        loading: false
      });
    case ApplicationCatalogActions.ActionType.LOAD_ERROR:
      return tassign(state, {
        error: action.payload,
        designSolutions: [],
        db: [],
        ledDB: null,
        service: APP_FACTORY_SERVICE_STATE_INIT,
        selectedSolution: null,
        loading: false
      });
    case ApplicationCatalogActions.ActionType.LOAD_COMPLETE:
      return tassign(state, {loadComplete: true});
    case ApplicationCatalogActions.ActionType.SELECT_SOLUTION:
      return tassign(state, {selectedSolution: action.payload});
    case ApplicationCatalogActions.ActionType.SET_LED_DB:
      return tassign(state, {ledDB: action.payload});
    case ApplicationCatalogActions.ActionType.SET_DESIGN_SOLUTIONS:
      const visibleElements = n => (!n.visibleOnGrid) || (n.visibleOnGrid && n.visibleOnGrid === 'true');
      return tassign(state,
        {
          designSolutions: R.filter(visibleElements, action.payload),
          unableToFindSolution: action.payload.length === 0
        });
    case ApplicationCatalogActions.ActionType.LOAD_DESCRIPTIONS_OF_SELECTED_SOLUTION:
      return tassign(state, {
        selectedSolution: {
          ...state.selectedSolution,
          loadingLocalizedDesc: true,
      }});
    case ApplicationCatalogActions.ActionType.LOADED_DESCRIPTIONS_OF_SELECTED_SOLUTION:
      return tassign(state, {
        selectedSolution: {
          ...state.selectedSolution,
          descriptions: action.payload,
          loadingLocalizedDesc: false,
        }});
    case ApplicationCatalogActions.ActionType.LOADED_DESCRIPTIONS_OF_SELECTED_SOLUTION_ERROR:
      return tassign(state, {
        selectedSolution: {
          ...state.selectedSolution,
          descriptions: null,
          loadingLocalizedDesc: false,
        }});
    default:
      return state;
  }
}

export function applicationContextReduce(state: IAppContext = APP_CONTEXT_STATE_INIT, action: any): IAppContext {
  switch (action.type) {
    case ApplicationContextActions.ActionType.SET_CONTEXT:
      return tassign(state, {context: action.payload});
    case ApplicationContextActions.ActionType.FRAME_MODE:
      return tassign(state, {frameMode: action.payload});
    default:
      return state;
  }
}

export function applicationConfigReduce(state: IAppConfig = APP_CONFIG_STATE_INIT, action: any): IAppConfig {
  switch (action.type) {
    case ApplicationConfigActions.ActionType.SET_CONFIG:
      return tassign(state, action.payload);
    default:
      return state;
  }
}

export const selectorRootReducer = combineReducers<ISelectorState>({
  appProjectTypes: applicationProjectTypesReducer,
  appToolBar: applicationToolbarReducer,
  appCatalog: applicationCatalogReducer,
  appSpec: applicationSpecReducer,
  appUserInfo: applicationUserInfoReduce,
  appContext: applicationContextReduce,
  appConfig: applicationConfigReduce,
  router: routerReducer
});

const designSolutions$ = (state => state.appCatalog.designSolutions);
